export const NAME = 'redeem';